import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'pv-action-button',
  templateUrl: './action-button.component.html',
  styleUrls: ['./action-button.component.scss']
})
export class ActionButtonComponent {
  @Input() label?: string;
  @Input() icon?: string;
  @Input() disabled: boolean = false;
  @Input() size: 'tiny' | 'small' | 'medium' | 'large' | 'giant' = 'small';
  @Input() type: 'button' | 'submit' | 'reset' = 'button';
  @Input() loading: boolean = false;
  
  @Output() click = new EventEmitter<Event>();

  get hasIcon(): boolean {
    return !!this.icon;
  }

  get hasLabel(): boolean {
    return !!this.label;
  }

  onClick(event: Event): void {
    console.log('ActionButton onClick called, disabled:', this.disabled, 'loading:', this.loading);
    
    if (!this.disabled && !this.loading) {
      event.preventDefault();
      event.stopPropagation();
      console.log('ActionButton emitting click event');
      this.click.emit(event);
    } else {
      console.log('ActionButton click blocked - disabled or loading');
    }
  }
}
